import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_LANG_VALUE, LANG_STORAGE_KEY } from './language/constants/language.constants';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {

  currentLang = localStorage.getItem(LANG_STORAGE_KEY) ?? DEFAULT_LANG_VALUE;

  constructor(private translate: TranslateService) {
    this.changeLanguage(this.currentLang);
  }

  changeLanguage(language: string) {
    this.currentLang = language;
    this.translate.setDefaultLang(this.currentLang);
    this.translate.use(this.currentLang);
    localStorage.setItem(LANG_STORAGE_KEY, language);
  }
}
